import { usePreviousValue } from 'app/lib/hooks/usePreviousValue/usePreviousValue.js';

export function useHasTransitionedToFalse(value) {
    const previousValue = usePreviousValue(value);
    return previousValue === true && value === false;
}
